import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationServiceTimePerService from "../../../components/organization/reports/daily/OrganizationServiceTimePerService";
import {
  SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationServiceTimePerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="ServiceTimePerService"
    title={`${reportIndex}. Service Time Per Service`}
  >
    {({ data, renderConfig }) => (
      <OrganizationServiceTimePerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationServiceTimePerService;
